import { createContext, useContext, useState, useMemo } from 'react';
import { useLocalStorage } from '../services/useLocalStorage';

export const SidebarVisibilityContext = createContext({ sidebarHidden: false });

const SidebarProvider = ({ children }) => {
  const [sidebarHidden, setSidebarHidden] = useState(false);
  // Homepage sidebar expand/collapse preference — shared here (rather than local to
  // AppSidebar) so the collapsed-state logo can render inside the page's scroll container.
  const [homeSidebarExpanded, setHomeSidebarExpanded] = useLocalStorage(
    'diffit-nav-sidebar-home',
    true
  );

  const value = useMemo(
    () => ({
      sidebarHidden,
      setSidebarHidden,
      homeSidebarExpanded,
      setHomeSidebarExpanded,
    }),
    [sidebarHidden, homeSidebarExpanded]
  );

  return (
    <SidebarVisibilityContext.Provider value={value}>{children}</SidebarVisibilityContext.Provider>
  );
};

export default SidebarProvider;

export const useSidebarVisibility = () => useContext(SidebarVisibilityContext);
